import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'xp-wait-dialog',
  templateUrl: './wait-dialog.component.html',
  styleUrl: './wait-dialog.component.scss'
})
export class WaitDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { message: string, onCancel: () => void },
        public dialogRef: MatDialogRef<WaitDialogComponent>
    ) { }

    cancel(): void {
        this.data.onCancel();
        this.dialogRef.close();
    }
}
